import { cloneElement, ReactElement, useLayoutEffect, useRef, useState } from 'react';

export interface AutoTitleProps {
  children: ReactElement;
  title: string;
}

const AutoTitle: React.FC<AutoTitleProps> = ({ children, title }) => {
  const ref = useRef<HTMLElement>();
  const [shouldShowTitle, setShouldShowTitle] = useState(false);

  useLayoutEffect(() => {
    const elem = ref.current;
    if (elem && elem.offsetWidth < elem.scrollWidth) {
      setShouldShowTitle(true);
    }
  }, []);

  return cloneElement(children, { ref, title: shouldShowTitle ? title : undefined });
};

export default AutoTitle;
